import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { Send_SEF_Emails } from "../../Registers/api/Send_SEF_Emails";
import { Send_Summer_SEF_Emails } from "../api/Send_Summer_SEF_Emails";

function SEFEmails() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([
    // Example customer objects

    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Summer Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        //{ Note: "28-day Email Sent", DateTime: "2024-10-24T10:00:00Z" },
        //{ Note: "14-day Email Sent", DateTime: "2024-10-20T10:00:00Z" },
        //{ Note: "7-day Email Sent", DateTime: "2024-10-12T10:00:00Z" },
        { Note: "72-hour Email Sent", DateTime: "2024-10-01T10:00:00Z" },
        { Note: "24-hour Email Sent", DateTime: "2024-10-04T10:00:00Z" },
        { Note: "Last-day Email Sent", DateTime: "2024-10-05T10:00:00Z" },
        { Note: "Deadline Email Sent", DateTime: "2024-10-06T10:00:00Z" },
      ],
    },

    // Add more customer objects as needed
  ]);

  useEffect(() => {
    // Get_All_From_MongoDB("Registers_2025", "All", setRegisters, logout);
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {
        ProgrammeVarient: "Week",
        ProgrammeTitle: "Summer",
        SEF: "Incomplete or In_Progress",
        //First_Name: "test",
      },
      30000,
      setRegisters,
      logout
    );
  }, []);

  const emailSequence = [
    "28-day Email Sent",
    "14-day Email Sent",
    "7-day Email Sent",
    "72-hour Email Sent",
    "24-hour Email Sent",
    "Last-day Email Sent",
    "Missed-deadline Email Sent",
  ];

  const emailIntervals = {
    "28-day Email Sent": 14 * 24 * 60 * 60 * 1000, // 14 days in milliseconds
    "14-day Email Sent": 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
    "7-day Email Sent": 4 * 24 * 60 * 60 * 1000, // 4 days in milliseconds
    "72-hour Email Sent": 2 * 24 * 60 * 60 * 1000, // 3 days in milliseconds
    "24-hour Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
    "Last-day Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
    "Missed-deadline Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
  };

  const getFirstEmail = (bookingDate) => {
    if (bookingDate <= new Date("2025-03-31")) {
      return "28-day Email Sent";
    } else if (bookingDate <= new Date("2025-04-30")) {
      return "14-day Email Sent";
    } else if (bookingDate <= new Date("2025-09-01")) {
      return "72-hour Email Sent";
    }
    return null;
  };

  const getNextEmail = (lastEmail) => {
    const index = emailSequence.indexOf(lastEmail);
    if (index >= 0 && index < emailSequence.length - 1) {
      return emailSequence[index + 1];
    }
    return null;
  };

  const determineDueEmail = (customer) => {
    let date = customer.BasicInfo?.Created_At || new Date().toISOString();
    let ProgrammeDate = customer.BasicInfo?.ProgrammeDate || "";

    if(ProgrammeDate === "(7th July - 18th July 2025)" || ProgrammeDate === "(28th July - 8th August 2025)") {
      return null;
    }

    const bookingDate = new Date(date);
    const notes = customer.Notes || []; // Default to an empty array if Notes is undefined

    // Filter notes to include only email-related notes
    const emailNotes = notes.filter((note) =>
      emailSequence.includes(note.Note)
    );

    // Filter out customers based on ProgrammeTitle
    const programmeTitle = customer?.BasicInfo?.ProgrammeTitle || "";
    if (!programmeTitle.toLowerCase().includes("summer")) {
      return null;
    }

    // Filter out customers based on complete progress
    const Progress = customer?.SEFInfo?.SEF;

    if (Progress === "Complete" || Progress === "Awaiting_Review") {
      return null;
    }

    //Remove Archived
    if (customer.MetaData?.Archived === "Yes") {
      return null;
    }

    //Remove those who have already submitted so far
    if (
      customer.SEFInfo?.SEFSubmissionDate &&
      customer.SEFInfo?.SEFSubmissionDate !== "" &&
      customer.SEFInfo?.SEFSubmissionDate !== null &&
      customer.SEFInfo?.SEFSubmissionDate !== undefined
    ) {
      return null;
    }

    //If no emailNotes, then the next email they need is the getFirstEmail
    if (emailNotes.length === 0) {
      return getFirstEmail(bookingDate);
    }

    const lastNote = emailNotes[emailNotes.length - 1];
    const lastEmail = lastNote.Note;
    const lastEmailDate = new Date(lastNote.DateTime);
    const now = new Date();

    if (now - lastEmailDate >= emailIntervals[lastEmail]) {
      return getNextEmail(lastEmail);
    }

    return null;
  };

  //Given an Array notes, see if there is an object with the value of Value in the Note prop
  const FindNote = (notes, Value) => {
    const Notes = notes || [];
    return Notes.find((note) => note.Note === Value);
  };

  function handleSend(e, chosenArray) {
    e.preventDefault();
    console.log("-----Start Send-----");

    //Get all customers with dueEmails as a prop
    const dueEmails = chosenArray.map((customer) => ({
      customer,
      dueEmail: determineDueEmail(customer),
    }));

    //Make sure we only have customers with dueEmails
    const dueEmailsFiltered = dueEmails.filter((dueEmail) => dueEmail.dueEmail);
    console.log("dueEmailsFiltered");
    console.log(dueEmailsFiltered);
    //filter each customer to keep only the BasicInfo and Contacts and IPInfo
    const smallAttendees = dueEmailsFiltered.map((attendeesFiltered) => {
      return {
        _id: attendeesFiltered.customer._id,
        BasicInfo: attendeesFiltered.customer?.BasicInfo || {},
        IPInfo: attendeesFiltered.customer.IPInfo || {},
        Password: attendeesFiltered.customer?.MetaData?.Password,
        Contacts: attendeesFiltered.customer?.Contacts,
        dueEmail: attendeesFiltered.dueEmail,
      };
    });
    // Filter the contacts array in each customer to only keep those with values in Person of either "Attendee" or "Parent". If there is neither, then the customer is removed. When removed, we log the customer.
    const AttendeesWithContacts = smallAttendees.map((oneAttendee) => {
      const Contacts = oneAttendee.Contacts || [];
      console.log("Contacts");
      console.log(Contacts);

      const AttendeeEmail = Contacts.find(
        (contact) => contact.Person === "Attendee"
      );
      const ParentEmail = Contacts.find(
        (contact) => contact.Person === "Parent"
      );
      if (AttendeeEmail || ParentEmail) {
        return {
          _id: oneAttendee._id,
          BasicInfo: oneAttendee.BasicInfo,
          IPInfo: oneAttendee.IPInfo || {},
          Password: oneAttendee.Password,
          Contacts: [AttendeeEmail, ParentEmail].filter((contact) => contact),
          dueEmail: oneAttendee.dueEmail,
        };
      } else {
        console.log("Customer without Attendee or Parent", oneAttendee);
        return null;
      }
    });
    // Filter out Attendees with no contacts again to be safe
    const AttendeesWithContactsFiltered = AttendeesWithContacts.filter(
      (Attendee) => Attendee
    );
    //loop through each customersWithContactsFiltered and consoel.log each and send
    AttendeesWithContactsFiltered.forEach((Attendee) => {
      console.log("Attendee");
      console.log(Attendee);
      let newNote = {
        DateTime: new Date().toISOString(),
        Note: Attendee.dueEmail,
        Staff_ID: localStorage.getItem("_id"),
      };
      console.log("newNote");
      console.log(newNote);
      console.log("-----End Send-----");

      Send_Summer_SEF_Emails(Attendee, newNote, logout);
    });
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View SEF Emails
          </Typography>
          <button
            style={{ width: "100px" }}
            onClick={(e) => handleSend(e, Registers)}
          >
            Send
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <>{SimpleTableHeader("_id")}</>
                  <>{SimpleTableHeader("Created At")}</>
                  <>{SimpleTableHeader("Name")}</>
                  <>{SimpleTableHeader("Title")}</>
                  <>{SimpleTableHeader("Date")}</>
                  <>{SimpleTableHeader("Varient")}</>
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Submission Date")}</>

                  {emailSequence.map((email, index) => (
                    <>{SimpleTableHeader("Got " + email + " ?")}</>
                  ))}
                  <>{SimpleTableHeader("Email Due")}</>
                  <>{SimpleTableHeader("SEF Stage")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {SimpleTableCell(Register?._id)}
                    {SimpleTableCell(Register?.BasicInfo?.Created_At)}
                    {SimpleTableCell(
                      Register?.BasicInfo?.First_Name +
                        " " +
                        Register?.BasicInfo?.Last_Name
                    )}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeDate)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeVarient)}
                    {SimpleTableCell(
                      Register?.IPInfo?.EC_ID &&
                        Register?.IPInfo?.EC_ID !== "" &&
                        Register?.IPInfo?.EC_ID !== null &&
                        Register?.IPInfo?.EC_ID !== undefined
                        ? "EC Booking"
                        : "Non EC Booking"
                    )}
                    {SimpleTableCell(Register?.SEFInfo?.SEFSubmissionDate)}
                    {emailSequence.map((email, index) => (
                      <>
                        {SimpleTableCell(
                          FindNote(Register?.Notes, email)?.Note
                        )}
                      </>
                    ))}
                    {SimpleTableCell(determineDueEmail(Register))}
                    {SimpleTableCell(Register?.SEFInfo?.SEF)}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {determineDueEmail(Register) ? (
                        <button onClick={(e) => handleSend(e, [Register])}>
                          Send
                        </button>
                      ) : (
                        ""
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default SEFEmails;
